import React, { JSX } from "react";
import { Box } from "@mui/material";
import { Search } from "@mui/icons-material";
import ClientSearch from "../../../components/ClientSearch";

interface OpdRequestClientSearchProps {
  selectedClient: any;
  setSelectedClient: React.Dispatch<React.SetStateAction<any>>;
}

const OpdRequestClientSearch = ({
  selectedClient,
  setSelectedClient
}: OpdRequestClientSearchProps): JSX.Element => (
  <Box
    sx={{
      height: "35px",
      padding: "0 10px",
      display: "flex",
      borderRadius: "5px",
      alignItems: "center",
      gap: "10px",
      overflow: "hidden",
      backgroundColor: "#ededed"
    }}
  >
    <Search />
    <ClientSearch
      client={selectedClient}
      setClient={setSelectedClient}
      margin="none"
      placeholder="Search client..."
      sx={(theme) => ({
        width: "200px",
        "@media (max-width: 768px)": {
          width: "180px",
          marginRight: "15px"
        },
        "&::placeholder": {
          color: "text.secondary"
        },
        "&:focus": {
          boxShadow: `0 0 0 2px ${theme.palette.primary.main}`
        }
      })}
    />
  </Box>
);

export default OpdRequestClientSearch;
